<template>
  <div class="brand-case-component">
    <div class="brand-section app-basic-layout-wrapper">
      <h3 class="title font-30">应用案例</h3>
      <p class="subtitle">查看其他商家如何通过品牌号取得成功</p>
      <div class="body">
        <div class="content-wrapper">
          <img src="@/assets/img/brand/case-bg.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.brand-case-component {
  background-color: #f4f5f7;
  .body {
    padding-top: 60px;
  }
  .content-wrapper {
    img {
      width: 100%;
    }
  }
}
</style>
